import router from '@/router'

export default {
   name: 'Offline'
}

window.addEventListener('online', function() {
   router.go(-1)
})
